import { ref, Ref } from "@vue/composition-api";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import providers from "@/lib/api";
import { UploadVaultFile } from "@/types";

export const useVaultFiles = (authUser: Ref<User | null>, selectedCategory: Ref<VaultCategory | null>) => {
  const movedFiles = ref<UploadVaultFile[]>([]);
  const setMovedFiles = (files: UploadVaultFile[]): void => {
    movedFiles.value = files;
  };

  let callBack: (() => void) | null = null;
  const setCallBack = (cb: () => void): void => {
    callBack = cb;
  };

  const moveLoading = ref<boolean>(false);
  const showMoveFilesConfirm = ref<boolean>(false);
  const moveFiles = async (categoryId: string) => {
    const fileIds = movedFiles.value.map(f => f.id);
    try {
      moveLoading.value = true;
      await providers.VaultsProvider.vaultFilesMove({
        data: { userId: authUser.value?.id ?? "", ids: fileIds, destCategoryId: categoryId },
      });

      showMoveFilesConfirm.value = false;
    } finally {
      callBack && callBack();
      moveLoading.value = false;
    }
  };

  const deleteLoading = ref<boolean>(false);
  const deleteFiles = async (fileIds: string[]): Promise<boolean> => {
    try {
      deleteLoading.value = true;
      return await providers.VaultsProvider.deleteFileFromCategory({
        data: { ids: fileIds, categoryId: selectedCategory.value?.id ?? "" },
      });
    } finally {
      deleteLoading.value = false;
    }
  };

  return {
    movedFiles,
    moveLoading,
    deleteLoading,
    showMoveFilesConfirm,
    moveFiles,
    deleteFiles,
    setCallBack,
    setMovedFiles,
  };
};
